export const ROUTES = {
  CAMPUS_NAVIGATION: '/campus-navigation',
  CAMPUS_DIRECTORY: '/campus-directory',
};
